import Vue from 'vue';
import store from '../vue/store/index';
import moment from "moment";

const months = [
    "Enero",
    "Febrero",
    "Marzo",
    "Abril",
    "Mayo",
    "Junio",
    "Julio",
    "Agosto",
    "Septiembre	",
    "Octubre",
    "Noviembre",
    "Diciembre"
  ];

function getInvitations(params) {

  return Vue.http.get('invited_client/get_invitations', {params}).then(response => {
    if (response.body.meta && response.body.meta.authentication_token) {
      store.commit('checkToken', response.body.meta.authentication_token);
    }
    const data = (response.body.data || []).map(item => transformInvitation(item));
    return {
      data,
      pagination: response.data.meta.pagination,
    }
  }).catch(error => {
    console.error(error);
  });
}

function transformInvitation(temp) {
  const attrs = temp.attributes;
  const invitationBy = attrs.user_name;
  return {
    id: temp.id,
    name: attrs.name,
    rut: attrs.rut,
    mobile: attrs.mobile,
    location: attrs.location_name,
    location_id: attrs.location_id,
    photo: attrs.photo,
    invitation_state: attrs.invitation_state,
    state: formatState(attrs.invitation_state),
    invitationBy,
    visitReason: attrs.reason_visit ? attrs.reason_visit : '',
    description: attrs.reason_visit_details ? attrs.reason_visit_details : '',
    approved: attrs.approved,
    reason_for_denied: attrs.reason_for_denied,
    date_from: dateFormat(
      moment(attrs.start_time).format(
        "MM/DD/YYYY - hh:mm A"
      )
    ),
    access_types: attrs.access_types || [],
    date_until: dateFormat(
      moment(attrs.end_time).format("MM/DD/YYYY - hh:mm A")
    ),
    start: attrs.start_time,
    end_date: attrs.end_time,
    vehicle_photo_url: attrs.vehicle_photo_url,
    equipment_photo_url: attrs.equipment_photo_url,
    invited_type: attrs.invited_type,
  }
}

function dateFormat(dates) {
  let sections = dates.split("/");
  let index = Number(sections[0]) - 1;
  sections[0] = months[index];
  dates = sections.join(" ");
  return dates;
}

function formatState(state) {
  const stateMap = {
    ACTIVE: "Creada",
    USED: "Activa",
    COMPLETED: "Usada",
    CANCELLED: "Cancelada",
    UNUSED: "No Usada"
  };
  return stateMap[state] || "";
}

function createInvitation(invitation) {
  return Vue.http.post('invitations/counter_invitation_with_identification', {
    data: invitation,
  })

}

function approveInvitation(invitation) {
  return Vue.http.post('invited_client/approve_invitation', {data: invitation});
}

async function deniedInvitation(invitation) {
  return Vue.http.post('invited_client/deny_invitation', {data: invitation});
}

async function validatePendingInvitations(params) {
  const resp = await Vue.http.get('invited_client/has_pending_invitations', {params});
  return resp.body;
}



export default {
  getInvitations,
  createInvitation,
  approveInvitation,
  deniedInvitation,
  validatePendingInvitations,
}



// WEBPACK FOOTER //
// ./src/services/invitations_services.js